import { getFeatureConfig } from '@luna/feature-config';

import { selectMyProfileData, useMyProfile } from './ProfileService';
import type { MyProfile } from './ProfileTypes';

export function useFullName(): string {
    const { data: profile } = useMyProfile();
    return createFullName(
        profile,
        getFeatureConfig((config) => config.profile.inverseNameOrder),
        getFeatureConfig((config) => config.profile.inverseNameOrderNationalities),
    );
}

export const getFullName = (): string => {
    const profile = selectMyProfileData();

    return createFullName(
        profile,
        getFeatureConfig((config) => config.profile.inverseNameOrder),
        getFeatureConfig((config) => config.profile.inverseNameOrderNationalities),
    );
};

function createFullName(
    profile?: Pick<MyProfile, 'firstname' | 'lastname' | 'nationality'>,
    isInverseNameOrder = false,
    inverseNameOrderNationalities: string[] = [],
): string {
    if (!profile || !profile.firstname || !profile.lastname) {
        return '';
    }

    const nationalityAllowsInverseNameOrder =
        profile.nationality && inverseNameOrderNationalities.includes(profile.nationality);

    if (isInverseNameOrder && nationalityAllowsInverseNameOrder) {
        return `${profile.lastname} ${profile.firstname}`;
    }

    return `${profile.firstname} ${profile.lastname}`;
}
